import { DEPLOYMENT_SETTING_TOGGLE_CODE_EXPORT } from './constants';

export function toggleCodeExport() {
  return {
    type: DEPLOYMENT_SETTING_TOGGLE_CODE_EXPORT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_TOGGLE_CODE_EXPORT:
      return {
        ...state,
        enableCodeExport: !state.enableCodeExport,
      };

    default:
      return state;
  }
}
